import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@material-ui/core';

const SearchPagination = ({
  onNext, onPrev, hasMore, hasPrev, scrollToTop, currentPage, totalPages,
}) => {
  const scrollTop = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  };

  const handleNext = () => {
    if (scrollToTop) scrollTop();
    onNext();
  };

  const handlePrev = () => {
    if (scrollToTop) scrollTop();
    onPrev();
  };

  return (
    <Box display="flex" alignItems="center" style={{ gap: 12 }}>
      <Button variant="outlined" size="small" disabled={!hasPrev} onClick={handlePrev}>
        Previous
      </Button>
      {totalPages > 0 && (
        <Typography variant="body2" color="textSecondary">
          {`Page ${currentPage} of ${totalPages}`}
        </Typography>
      )}
      <Button variant="outlined" size="small" disabled={!hasMore} onClick={handleNext}>
        Next
      </Button>
    </Box>
  );
};

SearchPagination.defaultProps = {
  hasMore: false,
  hasPrev: false,
  scrollToTop: false,
  currentPage: 1,
  totalPages: 0,
};

SearchPagination.propTypes = {
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
  hasMore: PropTypes.bool,
  hasPrev: PropTypes.bool,
  scrollToTop: PropTypes.bool,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
};

export default SearchPagination;
